import { Grid, Paper, Stack, Typography } from '@mui/material'
import { OrderNotesSubForm } from '@planning/pages/Order/V2/organisms/OrderNotesSubForm'
import { OrderFormStoreType } from '@planning/pages/Order/V2/stores/OrderFormStore'
import { useTranslate } from '@tolgee/react'
import { IFormStore } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'

export const OrderNotesCard = observer(
  ({ formStore }: { formStore: IFormStore<OrderFormStoreType> }) => {
    const { t } = useTranslate()

    return (
      <Stack spacing={2}>
        <Paper variant='outlined' sx={{ p: '1rem' }}>
          <Grid container spacing={2} direction={'column'}>
            <Grid>
              <Typography variant='subtitle1'>{t('notes', 'Notes')} </Typography>
            </Grid>
            <Grid>
              <Grid container spacing={2}>
                <Grid size={12}>
                  <OrderNotesSubForm formStore={formStore} initialValues={formStore.data} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Stack>
    )
  },
)
